export enum GraphicType {
    Sprite = 'sprite',
    NineSlice = '9slice',
    Animation = 'animation',
    Tiled = 'tiled'
}
